var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: none;\n        fill-rule: evenodd;\n        stroke: #D6CCFF;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.33,14.66c.74.74,1.93.74,2.66,0,0,0,5.22-5.22,5.22-5.22l.5.18c1.62.66,3.36.49,4.46-.61s1.32-3.78.66-5.4l-2.62,2.62-2.49.04h0s.04-2.48.04-2.48l2.62-2.62c-1.62-.66-4.3-.44-5.4.66s-1.28,2.84-.61,4.46l.18.5S1.34,12,1.34,12c-.74.74-.74,1.93,0,2.66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrench);
export default __webpack_public_path__ + "static/media/icon-wrench.439f323a2b6f57176803dd7792f1a2b6.svg";
export { ForwardRef as ReactComponent };